import { render, staticRenderFns } from "./DalinkPublicPage.vue?vue&type=template&id=95e3a63c&scoped=true"
import script from "./DalinkPublicPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DalinkPublicPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DalinkPublicPage.vue?vue&type=style&index=0&id=95e3a63c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e3a63c",
  null
  
)

export default component.exports